import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px 25px;
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  h5 {
    color: ${(props) => props.theme.colors.darkerblue};
  }

  a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 700;
    font-size: 13px;
    color: ${(props) => props.theme.colors.darkerblue};
  }
`;

export const InputWrapper = styled.div`
  border-radius: 12px;
  background: #fafafa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px 10px 10px;
  width: 45%;
`;

export const InputLabel = styled.a`
  font-size: 15px;
  width: 120px;
  color: ${(props) => props.theme.colors.label};
  font-weight: bold;
`;

export const InputIcon = styled.img`
  width: 14px;
  height: 14px;
  transform: rotate(90deg);
`;

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 30px 0px;
`;

export const Option = styled.div`
  height: 22px;
  width: 90%;

  font-size: 17px;
  padding: 10px 5px 10px 15px;

  display: flex;
  align-items: center;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  cursor: pointer;
  ${({ selected, props }) =>
    selected &&
    `background: ${props.theme.colors.disabled}; color:${props.theme.colors.black} `}

  :hover {
    background: ${(props) => props.theme.colors.disabled};
    color: ${(props) => props.theme.colors.black};
  }
`;

export const TrackVertical = styled.div`
  ${(props) => props.style}
  width: 10px;
  border-radius: 10px;
  background: ${(props) => props.theme.colors.lightergrey};
  right: 2px;
  bottom: 2px;
  top: 2px;
`;

export const ThumbVertical = styled.div`
  background: ${(props) => props.theme.colors.green};
  width: 10px;
  border-radius: 10px;
  ${(props) => props.opaque && 'opacity: 0.3'}
`;
